module.exports = __webpack_public_path__ + "static/media/vodafoneLogo.53015aad.png";